import React from "react"
import { Provider } from "react-redux"

import { createReduxStore } from "./src/store"
import { PersistGate } from "redux-persist/integration/react"
import { AnimateSharedLayout } from "framer-motion"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"

const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY)
// eslint-disable-next-line react/display-name,react/prop-types
export default (ssr = false) => ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  const [store, persistor] = createReduxStore({ persisted: !ssr })
  if (ssr) {
    return <Provider store={store}>{element}</Provider>
  }
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <AnimateSharedLayout>
          <Elements stripe={stripePromise}>{element}</Elements>
        </AnimateSharedLayout>
      </PersistGate>
    </Provider>
  )
}
